import React from 'react';
import "../assete/css/privacy.css";
import Header from './Header';
import terms_vdo from "../assete/image/privacy-policy-banner.png";
import Footer from './Footer';
import Whatsapp from './Whatsapp';
import Scrolltop from './Scrolltop';

const Privacy = () => {
  return (
<>
<Header/>
<div className='seasense_web_privacy_div'>
    <img src={terms_vdo} alt=""/> 

        <div className="about_content" >
    {/* <h1 data-aos="zoom-in" data-aos-duration="2000">Terms & Condition</h1> */}
    </div>
    </div> 

    <div className='privacy_main_div'>
        
        <h2>Privacy Policy</h2>
        <div class="line_payss"></div>
        <p>We use your data for providing and improving the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, accessible at www.seasensesoftwares.com Your data, including personal data, may be transferred to and kept on computers locatedoutside of your state, province, nation, or other government authority, where data protectionregulations may differ from those in your jurisdiction.</p>
        <p>If you are located outside of India and wish to provide us with information, please be aware that we will transfer and process your data, including personal data, in India.</p>
        <p>Your agreement to this transfer is based on your acceptance of this privacy policy and your submission of this information.</p>
        <p>Seasense will take all reasonable steps to ensure that your personal information is treated securely and in accordance with this Privacy Policy, and no personal information will betransferred to any organization or country unless appropriate controls, such as the security of your data and other personal information are in place.</p>
    </div>
    <Whatsapp/>
    <Scrolltop/>
    <Footer/>
</>
  )
}

export default Privacy